import { render } from "./StorePreview.vue?vue&type=template&id=31473bb0&scoped=true"
import script from "./StorePreview.vue?vue&type=script&lang=js"
export * from "./StorePreview.vue?vue&type=script&lang=js"

import "./StorePreview.vue?vue&type=style&index=0&id=31473bb0&lang=css"
import "./StorePreview.vue?vue&type=style&index=1&id=31473bb0&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31473bb0"]])

export default __exports__